import { Spin } from 'antd';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import http from '../../services/http';

function AuthCallbackView() {
  const location = useLocation();

  useEffect(() => {
    // Extract token from query parameters
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    const source = localStorage.getItem('360_source');

    if (token) {
      // Store the token (e.g., in localStorage)
      localStorage.setItem('token360', token);

      if (source) {
        http.post('/user/source', { source: source });
      }

      window.location.href = '/faq';
      window.location.reload();
    } else {
      console.error('No token found in the callback URL');
    }
  }, [location]);

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spin size='large' />
    </div>
  );
}

export default AuthCallbackView;
